import { P03_01 } from "./P03_01"

export const P03 = {
    "columns": 12,
    "rows": 3,
    "visual": {
        "id": 13,
        "type": "advancedTable",
        "colorTheme": "colorTheme1",
        "title": "Customer Channel Sales",
        "binding": {
            "data": {
                "columns": [
                    {
                        "name": 'Customer Channel',
                        "columnName": 'CustomerGroup',
                        "width": '180px',
                        "align": "left",
                        "sortable": true,
                        "sum": false
                    },
                    {
                        "name": 'Principal Code',
                        "columnName": 'DistributorCode',
                        "width": '180px',
                        "align": "left",
                        "sortable": true,
                        "sum": false
                    },
                    {
                        "name": 'Principal Name',
                        "columnName": 'DistributorName',
                        "width": '200px',
                        "align": "left",
                        "sortable": true,
                        "sum": false
                    },
                    {
                        "name": 'FTM Sales Actual',
                        "columnName": 'ActualSales',
                        "width": '180px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                    {
                        "name": 'LY FTM Sales Actual',
                        "columnName": 'LYSales',
                        "width": '200px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                    {
                        "name": 'Growth % FTM',
                        "columnName": 'Growth',
                        "width": '160px',
                        "align": "right",
                        "sortable": true,
                        "sum": false,
                        "percent": true
                    },
                    {
                        "name": 'YTD Sales Actual',
                        "columnName": 'YTDActualSales',
                        "width": '170px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                    {
                        "name": 'LY YTD Sales Actual',
                        "columnName": 'YTDLYSales',
                        "width": '190px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                    {
                        "name": 'Growth % YTD',
                        "columnName": 'YTDGrowth',
                        "width": '160px',
                        "align": "right",
                        "sortable": true,
                        "sum": false,
                        "percent": true
                    }
                ],
                "title": "CustomerGroup",
                "endpoint": "P03",
                "parameters": [
                    { "key": "FromMonth", "value": "2024" },
                    { "key": "FromYear", "value": "1" },
                    { "key": "ToMonth", "value": "2024" },
                    { "key": "ToYear", "value": "1" },
                    { "key": "ConfigTypeCode", "value": "" },
                    { "key": "DistributorCode", "value": "" }
                ]
            },
            "context": {
                "point": {
                    "onClick": P03_01
                }
            }
        }
    }
}